// Mainly use the hooks, these utils should only be used if you
//  need to check other groups than the current one

import { MODULE_NAME } from '@shared/constants/moduleAndPermissions';
import { Group, Permission, PermissionLevel } from '@shared/types';

import { PAGES } from '@ManagerPortal/constants/pages';

export const hasModule = (moduleName: MODULE_NAME, group: Group) =>
  group.accesses.modules.includes(moduleName);

export const hasPermission = (
  name: Permission,
  level: PermissionLevel,
  group: Group,
) => {
  const userLevel =
    (
      group.accesses.permissions.find(
        (permission) => permission.name === name.toUpperCase(),
      ) || {}
    ).access || '';

  return userLevel === 'WRITE'
    ? ['WRITE', 'READ'].includes(level.toUpperCase())
    : userLevel === level.toUpperCase();
};

export const hasAccess = (group: Group) =>
  !!group.accesses.permissions.find(
    (permission) => permission.access !== 'NONE',
  );

export const isCurrentGroup = (group: Group, currentGroupId: number) =>
  group.id === currentGroupId || group.parentGroupId === currentGroupId;

export const isPageAvailable = (
  page: keyof typeof PAGES,
  group: Group,
  account?: Group,
): boolean => {
  const pageData = PAGES[page];
  if (!pageData) return false;

  const checkAll = <T>(
    required: T[] | undefined,
    predicate: (item: T) => boolean | undefined,
  ) => !required?.length || required.every(predicate);

  const hasModules = checkAll(pageData.requiredModules, (module) =>
    hasModule(module, group),
  );

  const hasPermissions = checkAll(
    pageData.requiredPermissions,
    ({ name, level }) => hasPermission(name, level, group),
  );

  const hasAccountPermissions = checkAll(
    pageData.requiredAccountPermissions,
    ({ name, level }) => account && hasPermission(name, level, account),
  );

  return hasModules && hasPermissions && hasAccountPermissions;
};

export const getPage = (page: keyof typeof PAGES) => {
  return PAGES[page];
};
